import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateMerchantCreatedCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type MerchantCreatedState = void;

export const MERCHANT_CREATED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<MerchantCreatedState>>,
): ConditionType<MerchantCreatedState, Condition.MerchantCreated> => ({
  name: CONDITION_NAMES[Condition.MERCHANT_CREATED],
  description() {
    return t("Return was created by merchant");
  },
  Details(props: ConditionTypeDetailsProps<MerchantCreatedState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.MERCHANT_CREATED };
  },
  valid() {
    return validateMerchantCreatedCondition({}).valid;
  },
});
